/* Homepage image hero (prompt 123, sections/ssc-image-hero.liquid). Swipe = native scroll-snap; dots, pause, arrows,
   arrow keys. Autoplay every 5 s from page load: paused on hover / focus, stopped for good by a touch, a swipe, a key or a control (the
   visitor is in charge), never with prefers-reduced-motion. Slides 2+ carry their files in data-*: a slide gets its
   files when it's about to show (1.5 s before autoplay moves on, or the moment the visitor touches the hero), so a visit
   that doesn't move only downloads slide 1. Off-screen slides are inert. */
(() => {
  const root = document.querySelector('[data-ssc-ih]');
  const track = root?.querySelector('[data-ssc-ih-track]');
  if (!root || !track) return;
  const slides = [...track.querySelectorAll('[data-ssc-ih-slide]')];
  if (slides.length < 2) return;
  const dots = [...root.querySelectorAll('[data-ssc-ih-dot]')];
  const pauseBtn = root.querySelector('[data-ssc-ih-pause]');
  const live = root.querySelector('[data-ssc-ih-live]');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DELAY = 5000;
  const AHEAD = 1500;

  // Give a slide its real files (once).
  const load = (i) => {
    const slide = slides[(i + slides.length) % slides.length];
    if (!slide || slide.dataset.loaded) return;
    slide.dataset.loaded = '1';
    slide.querySelectorAll('[data-srcset]').forEach((el) => { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); });
    slide.querySelectorAll('img[data-src]').forEach((el) => { el.src = el.dataset.src; el.removeAttribute('data-src'); });
  };
  slides[0].dataset.loaded = '1';
  const near = () => { load(index - 1); load(index + 1); };

  let index = 0;
  let timer = null;
  let early = null;
  let hovered = false;
  let focused = false;
  let stopped = still.matches;

  const paint = (announce) => {
    slides.forEach((s, n) => { s.inert = n !== index; });
    dots.forEach((d, n) => (n === index ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
    if (announce && live) live.textContent = `Slide ${index + 1} of ${slides.length}`;
  };
  const go = (i, announce) => {
    index = (i + slides.length) % slides.length;
    load(index);
    track.scrollTo({ left: index * track.clientWidth, behavior: still.matches ? 'auto' : 'smooth' });
    paint(announce);
  };
  const tick = () => {
    clearTimeout(timer);
    clearTimeout(early);
    timer = null;
    if (stopped || hovered || focused || document.hidden) return;
    early = setTimeout(() => load(index + 1), DELAY - AHEAD);
    timer = setTimeout(() => { go(index + 1, false); tick(); }, DELAY);
  };
  const stop = () => {
    if (stopped) return;
    stopped = true;
    pauseBtn?.setAttribute('aria-pressed', 'true');
    pauseBtn?.setAttribute('aria-label', 'Play the slideshow');
    tick();
  };

  // The slide on screen after a swipe (scroll settles).
  let settle = null;
  track.addEventListener('scroll', () => {
    clearTimeout(settle);
    settle = setTimeout(() => {
      const i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i !== index) { index = Math.max(0, Math.min(slides.length - 1, i)); load(index); paint(true); }
      near();
    }, 90);
  }, { passive: true });

  // Any touch on the hero: the neighbours get their files (a swipe is coming) and autoplay stops.
  track.addEventListener('pointerdown', (e) => { near(); if (e.pointerType === 'touch') stop(); });
  track.addEventListener('touchstart', near, { passive: true });
  track.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { near(); stop(); } }, { passive: true });

  root.querySelector('[data-ssc-ih-prev]')?.addEventListener('click', () => { stop(); go(index - 1, true); });
  root.querySelector('[data-ssc-ih-next]')?.addEventListener('click', () => { stop(); go(index + 1, true); });
  dots.forEach((d) => d.addEventListener('click', () => { stop(); go(Number(d.dataset.sscIhDot), true); }));
  pauseBtn?.addEventListener('click', () => {
    if (stopped) {
      stopped = false;
      pauseBtn.setAttribute('aria-pressed', 'false');
      pauseBtn.setAttribute('aria-label', 'Pause the slideshow');
      tick();
    } else {
      stop();
    }
  });
  if (still.matches) {
    pauseBtn?.setAttribute('aria-pressed', 'true');
    pauseBtn?.setAttribute('aria-label', 'Play the slideshow');
  }
  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index + 1, true); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(index - 1, true); }
  });
  root.addEventListener('mouseenter', () => { hovered = true; tick(); });
  root.addEventListener('mouseleave', () => { hovered = false; tick(); });
  root.addEventListener('focusin', () => { focused = true; tick(); });
  root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { focused = false; tick(); } });
  document.addEventListener('visibilitychange', tick);
  // Keep the slide in place when the width changes (rotation, resize).
  new ResizeObserver(() => track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' })).observe(track);

  paint(false);
  // Autoplay (and with it the next slide's files) starts once the page has loaded, so nothing competes with slide 1.
  if (document.readyState === 'complete') tick();
  else window.addEventListener('load', tick, { once: true });
})();
